import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLoginVisible } from '../../Slice/DialogSlice';
import { AppDispatch, RootState } from '../../Store';

export default function LandingpageHeader() {

    //const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();

    function handleShowLoginDialog() {
        dispatch(setLoginVisible(true));
    }

    useEffect(() => {
       
    }, [])

    return (
        <>
        {/*<div className={styles.headerContainer}>

            <div className={styles.headerLogo}>
                <img
                    className={styles.logo}
                    alt="s" src={window.location.pathname === '/' ? logoNegativ : logoPositiv}
                    onClick={() => {
                        navigate({
                            pathname: '/'
                        })
                    }}
                />
            </div>

            <div className={styles.headerLoginArea}>
                {(auth.isAuthCheckFinished &&
                    <>
                        {(auth.isAuthenticated === false) ?

                            <button
                                className="btn btn-primary pg-btn-login"
                                onClick={handleShowLoginDialog}
                                style={{padding:"10px 50px", fontWeight:"bold", fontSize:"1.0rem"}}
                            > Login </button>

                            :
                            <>
                                <span title="Account" onClick={() => navigate("/account")}><i title="Account" className='bi bi-person-circle' style={{ cursor: "pointer" }} ></i></span>

                                {auth.user?.email}

                             
                            </>
                        }
                    </>)}

            </div>

        </div >*/}
        </>
    );
}

